import SubscriptionExpired from '../components/expirateSubscription.js';
import Unauthorized from '../components/unauthorize.js';
import PasswordModify from '../views/clientviews/staffmanagment/profilpage.js';
import Generalcongig from '../views/Hospitalconfiguration/generalconfig'; 
import {ProtectedDashboard,
  ProtectedPatientList,
  ProtectedSpeciality,
  ProtectedStaffList,
  ProtectedNewAppointment,
  ProtectedPatientfilemedical,
  ProtectedMedicalhistory,
  ProtectedPaymentCaisse,
  ProtectedReceiptPayment,
  ProtectedDepartment,
  ProtectedHospitalSetting,
  ProtectedLocationSetting,
  ProtectedPatientCard,
  ProtectedAppointments,
  ProtectedAppointmentHistory,
  ProtectedMedicalAppointments,
  ProtectedCalendarWeekView,
  ProtectedStaffDetails,
  ProtectedStaffSchedule,
  ProtectedStaffScheduleEdit,
  ProtectedTelMed,
  ProtectedOrdonnance,
  ProtectedAppoint,
  ProtectedAppointmentprocess,
  ProtectedDoctoragenda,
  ProtectedPatientdontknow,
  ProtectedSchedulerdv,
  ProtectedEditappointment,
  ProtectedPrintbillingTicket,
  ProtectedRoomsList,
  ProtectedSummaryhospitalization,
  ProtectedAppointmentlistNurses,
  ProtectedSignvitalForm,
  ProtectedDoctorDashboard,
  ProtectedDoctorPatientDetails,
  ProtectedDoctorCalendar,
  ProtectedDoctorAppointment,
  ProtectedDoctorHistory,
  ProtectedDoctorIntakeConsult,
  ProtectedConsultaiondetails,
  ProtectedOrdonnancegenerate,
  ProtectedInfirmier,
  ProtectedDocteur,
  ProtectedPaymentlist,
  ProtectedInvoiceAssurance,
  ProtectedGeneralcongig,
  ProtectedHospitalDashboard,
  ProtectedEditLocation,
  ProtectedHospitalDetails,
  ProtectedPatientDataPrivacy,
  ProtectedStaffPlan,
  ProtectedRolePermissionManager} from '../guard/protectDash.js';
import UpdateSubscription from '../views/authentification/updateplan.js';


const ClientRoutesWithDash = [
  { path: '/hospitaladmin/dashboard', name: 'Dashboard', element: ProtectedDashboard },
  { path: '/hospitaladmin/userprofile', name: 'PasswordModify', element: PasswordModify },
  { path: '/hospitaladmin/patientPrivacy', name: 'Patient Privacy', element: ProtectedPatientDataPrivacy },
  { path: '/hospitaladmin/patientlist', name: 'Patient Management', element: ProtectedPatientList },
  { path: '/hospitaladmin/patientfilemedical/:patientId', name: 'patientfilemedical', element: ProtectedPatientfilemedical , exact: true },
  { path: '/hospitaladmin/department', name: 'department', element: ProtectedDepartment , exact: true },
  { path: '/hospitaladmin/speciality', name: 'Speciality', element: ProtectedSpeciality , exact: true },
  { path: '/hospitaladmin/stafflist', name: 'StaffList', element: ProtectedStaffList , exact: true },
  { path: '/hospitaladmin/rolemanage', name: 'StaffList', element: ProtectedRolePermissionManager , exact: true },
  { path: '/hospitaladmin/staffschedule', name: 'StaffList', element: ProtectedStaffPlan , exact: true },
  { path: '/hospitaladmin/addappointment', name: 'NewAppointment', element: ProtectedNewAppointment , exact: true },
  { path: '/hospitaladmin/medicalhistory', name: 'Medicalhistory', element: ProtectedMedicalhistory , exact: true },
  { path: '/hospitaladmin/payment', name: 'PaymentCaisse', element: ProtectedPaymentCaisse },
  { path: '/hospitaladmin/receiptpay', name: 'ReceiptPayment', element: ProtectedReceiptPayment },
  { path: '/hospitaladmin/hospitalsetting', name: 'HospitalSetting', element: ProtectedHospitalSetting },
  { path: "/subscription/expired", element: SubscriptionExpired},
  { path: "/unauthorized", element: Unauthorized },
  { path: "/subscription/upgradeplan", element: UpdateSubscription },
  { path: '/hospitaladmin/locationSetting', name: 'LocationSetting', element: ProtectedLocationSetting },
  { path: '/hospitaladmin/hospitalDetails/:hospitalId', name: 'HospitalDetails', element: ProtectedHospitalDetails },
  { path: '/hospitaladmin/editLocation/:hospitalId', name: 'EditLocation', element: ProtectedEditLocation },
  { path: '/patientcard/:patientId', name: 'PatientCard', element: ProtectedPatientCard },
  { path: '/hospitaladmin/appointment', name: 'Appointment', element: ProtectedAppointments },
  { path: '/hospitaladmin/appointment_history', name: 'AppointmentHistory', element: ProtectedAppointmentHistory },
  { path: '/hospitaladmin/patient_details', name: 'PatientDetail', element: ProtectedMedicalAppointments },
  { path: '/hospitaladmin/appoint_calendar', name: 'AppointCalendar', element: ProtectedCalendarWeekView },
  { path: '/hospitaladmin/staff_details', name: 'StaffDetails', element: ProtectedStaffDetails },
  { path: '/hospitaladmin/staff_schedule', name: 'StaffSchedule', element: ProtectedStaffSchedule },
  { path: '/hospitaladmin/staff_schedule_edit', name: 'StaffSchedule', element: ProtectedStaffScheduleEdit },
  { path: '/hospitaladmin/telemedecine', name: 'StaffSchedule', element: ProtectedTelMed },
  { path: '/hospitaladmin/telemedecine/:meetingCode', name: 'TelemedicineCall', element: ProtectedTelMed },


  // Ordonnance
  { path: '/hospitaladmin/telemedecine/ordornance', name: 'Ordonnance', element: ProtectedOrdonnance },
  { path: '/hospitaladmin/telemedecine/ordornance/:consultationId', name: 'Ordonnance', element: ProtectedOrdonnance },
  { path: '/hospitaladmin/telemedecine/appoint', name: 'Appoint', element: ProtectedAppoint },
  

  // Appointment
  { path: '/hospitaladmin/appointmentprocess', name: 'Appointmentprocess', element: ProtectedAppointmentprocess },
  { path: '/hospitaladmin/doctoragenda', name: 'Doctoragenda', element: ProtectedDoctoragenda },
  { path: '/hospitaladmin/patientdontknow', name: 'Patientdontknow', element: ProtectedPatientdontknow },
  { path: '/hospitaladmin/schedulerdv', name: 'Schedulerdv', element: ProtectedSchedulerdv },
  { path: '/hospitaladmin/editappointment/:id', name: 'Editappointment', element: ProtectedEditappointment },
  { path: '/hospitaladmin/printbillingticket/:id', name: 'PrintbillingTicket', element: ProtectedPrintbillingTicket },



  // nurses appointment liste
  { path: '/hospitaladmin/Appointmentlist', name: 'AppointmentlistNurses', element: ProtectedAppointmentlistNurses },
  { path: '/appointment/:appointmentId/signvital', name: 'SignvitalForm', element: ProtectedSignvitalForm },


  // Doctor
  { path: '/hospitaladmin/doctor/overviews', name: 'Overviews', element: ProtectedDoctorDashboard },
  { path: '/hospitaladmin/doctor/patientdetail', name: 'Patientdetail', element: ProtectedDoctorPatientDetails },
  { path: '/hospitaladmin/doctor/ordonnancegenerate', name: 'Ordonnancegenerate', element: ProtectedOrdonnancegenerate },
  { path: '/hospitaladmin/doctor/calendar/:doctorId', name: 'Calendar', element: ProtectedDoctorCalendar },
  { path: '/hospitaladmin/doctor/appointment', name: 'Appointment', element: ProtectedDoctorAppointment },
  { path: '/hospitaladmin/doctor/appointement_history', name: 'Appointement_history', element: ProtectedDoctorHistory },
  { path: '/infirmier', name: 'Infirmier', element: ProtectedInfirmier },
  { path: '/docteur', name: 'Docteur', element: ProtectedDocteur },
  { path: '/hospitaladmin/intakeformconsult', name: 'intake form', element: ProtectedDoctorIntakeConsult },
  { path: '/hospitaladmin/consultation-details/:consultationId', name: 'details', element: ProtectedConsultaiondetails },

  { path: '/report', name: 'Report', element: ProtectedHospitalDashboard },


  // Room managment
  { path: '/hospitaladmin/rooms_list', name: 'RoomsList', element: ProtectedRoomsList },
  { path: '/hospitaladmin/summaryhospitalisation/:id', name: 'Summaryhospitalization', element: ProtectedSummaryhospitalization },


  // hospita setting
  { path: '/hospitaladmin/generalconfig', name: 'Generalcongig', element: Generalcongig },

  // billing
  { path: '/Billings/allpaymentlist', name: 'Paymentlist', element: ProtectedPaymentlist },
  { path: '/Billings/invoiceAssurance/:billingID', name: 'InvoiceAssurance', element: ProtectedInvoiceAssurance },


  // Ajoutez ici d'autres routes qui nécessitent un sidebar
];

export default ClientRoutesWithDash;

